import React from 'react'

export default ({user}) => (
    <figure className='mvu-user'>
        <div className='mvu-user-img-wrap'>
            {user.image ? <img src='' alt=''/> : <div className='mvu-user-img-anonymous' style={{backgroundColor: user.color}}></div>}
        </div>
        <figcaption>
            <p>{user.displayName}</p>
        </figcaption>
    </figure>
)


// WEBPACK FOOTER //
// ./src/components/widgets/user.js